export default {
      id: "help__track_icon-usage",
      viewBox: "0 0 45 53",
      url: __webpack_public_path__ + "img/icons.svg#help__track_icon",
      toString: function () {
        return this.url;
      }
    }